import {Pipe, PipeTransform} from "@angular/core";
import {TriagemService} from "../../../service/triagem.service";
import {map, Observable} from "rxjs";

@Pipe({
  name: 'totalReservadas',
  standalone: true
})
export class TotalReservadasPipe implements PipeTransform {

  transform(triagemService: TriagemService): Observable<number> {
    return triagemService.infracoesAvaliarDepois$.pipe(
      map(reservadas =>
        reservadas.getReservadasEmTela()
          .map(r => r.numbers.length)
          .reduce((acc, value) => acc + value, 0)
      )
    );
  }

}
